import React from 'react';
import { RouteComponentProps } from '@reach/router';
import AppPromoCodeShared from '../shared-component';
import Layout from '../../../components/layout';

interface Props extends RouteComponentProps {
  appName?: string;
  partnerId?: string;
}

const AppPromoCodeWithPartner: React.FC<Props> = ({ appName = '', partnerId = '' }) => {
  return (
    <Layout>
      <AppPromoCodeShared appName={appName} partnerId={partnerId} />
    </Layout>
  );
};

export default AppPromoCodeWithPartner; 